import { useCallback } from 'react';

import { useSidebar } from '../components/shadcn-ui/sidebar';
import { useNavigationStore } from '../context/zustand/navigationStore';
import { potreeTools } from '../utils/potreeTools';
import { usePotree } from './usePotree';
import { useToggleAnnotationVisibility } from './useToggleAnnotationVisibility';

export const useTogglePanoramaTour = () => {
  const navigationState = useNavigationStore();
  const { potreeViewer } = usePotree();
  const { setOpen: setSidebarOpen } = useSidebar();

  const toggleAnnotationVisibility = useToggleAnnotationVisibility();

  const togglePanoramaTour = useCallback(() => {
    const { keyboardEvents, enableKeyboardEvents, disableKeyboardEvents } =
      navigationState;
    if (keyboardEvents === 'enabled') {
      disableKeyboardEvents();
      // NOTE: close the slides sidebar as a workaround to suppress navigating through slides
      setSidebarOpen(false);
    } else if (keyboardEvents === 'disabled') {
      enableKeyboardEvents();
      setSidebarOpen(true);
    } else {
      throw Error(`Unsupported keyboardEnvents value: ${keyboardEvents}`);
    }
    // Hide all scene annotations if entering panorama mode, and vice versa
    toggleAnnotationVisibility();
    // Finally, toggle the panorama mode itself
    potreeTools.togglePanoramaTour(potreeViewer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigationState, potreeViewer]);

  const exitPanoramaTour = useCallback(() => {
    const { enableKeyboardEvents } = navigationState;
    enableKeyboardEvents();
    setSidebarOpen(true);
    potreeTools.exitPanoramaTour(potreeViewer);
  }, [navigationState, potreeViewer, setSidebarOpen]);

  return { togglePanoramaTour, exitPanoramaTour };
};
